<template>
  <div class="panel panel-default">
    <div class="panel-body">
      <div class="row">
        <form class="form-horizontal" style="padding-top:10px" id="bs_form">
          <div class="col-sm-3">
            <div class="form-group">
              <label class="col-sm-3 control-label">套餐名称</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  v-model="query.tcmc"
                  name="tcmc"
                  v-validate="{ required: true, max: 50 }"
                  data-vv-as="用户名"
                  class="form-control"
                  placeholder=""
                />
              </div>
            </div>
          </div>

          <!-- 模式：学历类型 -->
          <div class="col-sm-3">
            <div class="form-group">
              <label class="col-sm-3 control-label">模式</label>
              <div class="col-sm-9">
                <select
                  class="form-control"
                  v-model="query.xllx"
                  name="js"
                  v-validate="{ required: true }"
                  data-vv-as="模式"
                >
                  <option value="">--请选择--</option>
                  <option
                    v-for="xllx in xllxArr"
                    :value="xllx.value"
                    :key="xllx.value"
                    >{{ xllx.text }}</option
                  >
                </select>
              </div>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label class="col-sm-3 control-label">启用状态</label>
              <div class="col-sm-9">
                <select name="zycc" class="form-control" v-model="query.sfky">
                  <option value="">-请选择-</option>
                  <option
                    :value="sfky.value"
                    :key="sfky.value"
                    v-for="sfky in sfkyList"
                    >{{ sfky.text }}</option
                  >
                </select>
              </div>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="pull-right">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style="margin-right:3px"
                @click="search()"
              >
                <i class="fa fa-search" aria-hidden="true"></i>查询
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="add()"
              >
                <i class="fa fa-plus" aria-hidden="true"></i>添加套餐
              </button>
            </div>
          </div>
        </form>
      </div>

      <!-- 表格部分 -->
      <div class="row">
        <div class="col-sm-12" style="padding-top: 10px">
          <BootstrapTable
            style="font-size: 14px;"
            ref="table"
            v-once
            :columns="columns"
            :options="{
              classes: 'table table-hover',
              undefinedText: '',
              showColumns: false,
              sidePagination: 'server',
              pagination: true,
              pageNumber: 1,
              pageSize: 10,
              pageList: [10, 50, 100, 500],
              paginationPreText: '上一页',
              paginationNextText: '下一页',
              showExtendedPagination: true,
              paginationLoop: false,
            }"
            @onPostBody="vueFormatterPostBody"
            @onPageChange="pageChange"
          />
        </div>
      </div>
    </div>
    <PackageMgCheck ref="PackageMgCheck"></PackageMgCheck>
  </div>
</template>

<script>
import tableMixin from "@/mixins/table.js";
import { xllx, checkTypeMap } from "@/plugins/enums.js";
import PackageMgCheck from "./package-mg-check";
export default {
  name: "PackageMg",
  mixins: [tableMixin],
  components: {
    PackageMgCheck
  },
  data() {
    return {
      sfkyList: [
        {
          value: 0,
          text: "否",
        },
        {
          value: 1,
          text: "是",
        },
      ],
      // 学历类型下拉
      xllxArr: [],
      activeIndex: 0,
      jsList: [],
      query: {
        tcmc: "",
        sfky: "",
        xllx: "",
      },

      columns: [
        {
          title: "序号",
          field: "id",
          align: "center",
          formatter: (value, row, index) => {
            var options = this.$refs.table.getOptions();
            return options.pageSize * (options.pageNumber - 1) + index + 1;
          },
        },
        {
          field: "tcmc",
          title: "收费套餐名称",
        },

        {
          field: "cjsj",
          title: "创建时间",
        },
        {
          field: "cjyh",
          title: "创建用户",
        },
        // 0 fou    1   是
        {
          field: "sfky",
          title: "是否可用",
          formatter: (value, row) => {
            return row.sfky == 1 ? "是" : "否";
          },
        },
        {
          field: "zt",
          title: "审核状态",
          formatter: (value, row, index) => {
            return checkTypeMap[value];
          },
        },
        {
          field: "shsj",
          title: "审核时间",
        },
        {
          field: "shyh",
          title: "审核用户",
        },
        {
          field: "xllx",
          title: "学历类型",
          formatter: (value) => {
            let p = {
              ZXKS: "自学考试",
              CRJY: "成人教育",
              WLJY: "网络教育",
              GJKFDX: "国家开放大学",
              PTZSB: "普通专升本",
              GJKFDX: "国家开放大学",
              ZYZGZS: "职业资格证书",
            };
            return p[value] || "";
          },
        },
        {
          field: "actions",
          title: "操作",
          align: "center",
          formatter: (value, row) => {
            let btnHtml='';
            if(row.zt=='WAIT'){
                btnHtml+=' | <a @click="check(row)">审核</a>';
            }
            return this.vueFormatter({
              template: '<div class="operation_column"><a @click="edit(row)">修改</a>'+btnHtml+'</div>',
              data: { row },
              methods: {
                edit: this.edit,
                check: this.check,
              },
            });
          },
        },
      ],
    };
  },
  created() {
    this.xllxArr = xllx;
  },
  mounted() {
    this.query = Object.assign(
      this.query,
      { current: 1, size: 10 },
      this.$route.query
    );
    this.load();
  },
  beforeRouteUpdate(to, from, next) {
    this.query = Object.assign(this.query, { current: 1, size: 10 }, to.query);
    this.load();
    next();
  },
  methods: {
    update() {
      this.search();
    },
    // 查询
    search() {
      let query = Object.assign(
        this.query,
        { current: 1, size: 10 },
        { _t: new Date().getTime() }
      );
      this.$router.push({ name: this.$route.name, query: query });
    },
    add() {
      this.$router.push({ name: "PackageMgAdd" });
    },
    // 审核
    check(row) {
        this.$refs.PackageMgCheck.open(row);
    },

    //   修改
    edit(row) {
      this.$router.push({ name: "PackageMgEdit", query: row });
    },
    // tab切换
    onclick(num) {
      this.activeIndex = num;
    },

    load: function(pageNumber, pageSize) {
      this.query.current = pageNumber || this.query.current;
      this.query.size = pageSize || this.query.size;
      let poUrl = "/htgl/biz/cw/tc/page";
      this.$http.get(poUrl, this.query).then((res) => {
        if (res.code == 0) {
          let data = {
            total: res.data.total,
            rows: res.data.records,
          };
          this.$refs.table.load(data);
          //table加载返回的数据
          this.$refs.table.load(data);
          this.$refs.table.refreshOptions({
            pageNumber: parseInt(this.query.current),
            pageSize: parseInt(this.query.size),
          });
        }
      });
    },
    // 页码改变
    pageChange: function(pageNumber, pageSize) {
      let query = Object.assign(
        this.query,
        { current: pageNumber, size: pageSize },
        { _t: new Date().getTime() }
      );
      this.$router.push({ name: this.$route.name, query: query });
    },
  },
};
</script>